/**
 * Whether the entry screen should exist right now. The composition root
 * decides on boot (no saved place -> splash); the React splash renders while
 * wanted and retires itself on entry. It can be wanted AGAIN: "Back to
 * entrance" in the menu puts a student who is already inside back at the
 * airlock without rebuilding the hall, and the screen simply comes up over
 * the room that is still there.
 */

let wanted = false
const listeners = new Set<() => void>()

function notify(): void {
  for (const fn of [...listeners]) fn()
}

export const splashStore = {
  get wanted(): boolean {
    return wanted
  },
  show(): void {
    if (wanted) return
    wanted = true
    notify()
  },
  /** The screen has faded out; the student is in. */
  hide(): void {
    if (!wanted) return
    wanted = false
    notify()
  },
  subscribe(fn: () => void): () => void {
    listeners.add(fn)
    return () => {
      listeners.delete(fn)
    }
  },
}
